/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityStatusType } from '../../models/facility-status-type';

export interface FacilityClinicGroupIdIdUpdateStatusStatusPost$Params {
  clinicGroupId: string;
  id: string;
  status: FacilityStatusType;
}

export function facilityClinicGroupIdIdUpdateStatusStatusPost(http: HttpClient, rootUrl: string, params: FacilityClinicGroupIdIdUpdateStatusStatusPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, facilityClinicGroupIdIdUpdateStatusStatusPost.PATH, 'post');
  if (params) {
    rb.path('clinicGroupId', params.clinicGroupId, {});
    rb.path('id', params.id, {});
    rb.path('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as PracticeStrictHttpResponse<void>;
    })
  );
}

facilityClinicGroupIdIdUpdateStatusStatusPost.PATH = '/Facility/{clinicGroupId}/{id}/UpdateStatus/{status}';
